<template>
  <div class="flex flex-col w-screen">
    <div class="container">
      <div style="position: absolute;top: -30px;left:10px;color: #fffffd;cursor:pointer;">
        <span @click="$router.push({ path: '/' })">首页</span> /
        <span>{{ firstMenuName }}</span> /
        <span v-if="menuName">{{ menuName }}</span>
      </div>
      <div class="dropdown">
        <div class="dropdown-header" >
          <p> {{firstMenuName}}</p>
          <p class="el-icon-plus" @click="toggleDropdown()" v-if="!isShowSelect"></p>
          <p class="el-icon-minus" @click="toggleDropdown()" v-else></p>
        </div>
        <div class="dropdown-content" id="dropdownContent">
          <div  v-for="(item, i) in menuList"
                @click="toList(item.id, item.label,i)"
                :key="i"
                :title="item.label"
                :class="activeMenuIndex==i?'active_dropdown-item':'dropdown-item'"
          >
            <p>{{item.label}}</p>
            <img src="@/assets/list/active.png" alt="" style="width: 24px;height: 20px" v-if="activeMenuIndex!=i">
            <img src="@/assets/list/actived.png" alt="" style="width: 24px;height: 20px" v-else>
          </div>
        </div>
      </div>
      <div id="right-content" class="rightContent">
        <div v-show="!showIframe && !showBadRecord" style="margin-top: 20px">
          <div id="article-header">
            {{ content.title }}
          </div>
          <div id="article-info">
            <span class="info-text">来源:{{ content.source }}<el-divider direction="vertical"></el-divider></span>
            <span class="info-text">作者:{{ content.author }}<el-divider direction="vertical"></el-divider></span>
            <span class="info-text">时间:{{ content.addDate }}<el-divider direction="vertical"></el-divider></span>
            <span class="info-text">点击:{{ content.hits }}</span>
          </div>
          <el-divider></el-divider>
          <div>
            <div  class="content"  id="newsContent" ></div>
          </div>
          ​
          <div
            v-for="(item, index) in content.files"
            :key="index"
            style="width: 100%; text-align: center"
          >
            <!-- <iframe

              :src="
                '/mainsys/cmsapi/getFilePath?fileId=' + item.id + '&password='
              "
              width="500px"
              height="280px"
            ></iframe> -->
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                width: 100%;
              "
              v-if="
                item.fileSuffix == '.MP4' ||
                item.fileSuffix == '.mp4' ||
                item.fileSuffix == 'MP4' ||
                item.fileSuffix == 'mp4'
              "
            >
              <video width="480" height="400" controls>
                <source
                  :src="
                    '/mainsys/cmsapi/getFilePath?fileId=' +
                    item.id +
                    '&password='
                  "
                  type="video/mp4"
                />
              </video>
            </div>

            <iframe
              v-if="
                item.fileSuffix == '.pdf' ||
                item.fileSuffix == '.PDF' ||
                item.fileSuffix == 'PDF' ||
                item.fileSuffix == 'pdf'
              "
              :src="
                '/mainsys/cmsapi/getFilePath?fileId=' + item.id + '&password='
              "
              width="90%"
              height="600px"
            ></iframe>
            <a
              href="#"
              @click="downloadFile(item)"
              style="display: block; width: 100%; margin: 12px 0 24px 0"
            >{{ item.fileName }}</a
            >
          </div>

          <!-- <div
            style="margin: 10px 0 0 40px;"
            v-if="content.files && content.files.length > 0"
          >
                     <span style="font-size:18px;font-weight:600;color:rgba(203,203,203,1);">附件下载</span>
            <div v-for="(item, index) in content.files">
              <a
                :href="'/mainsys/cmsapi/getFilePath?fileId=' + item.id"
                target="_blank"
                >{{ item.fileName }}</a
              >
              <a href="#" @click="downloadFile(item)">{{ item.fileName }}</a>
            </div>
            <div
              v-for="(item, index) in content.files"
              v-if="item.fileSuffix != '.MP4' && item.fileSuffix != '.mp4'"
            >
              <a href="#" @click="downloadFile(item)">{{ item.fileName }}</a>
            </div>
          </div> -->
        </div>

        <div v-show="showBadRecord">
          <!--显示不良记录-->
          <el-table
            default-expand-all
            stripe
            :data="mainData"
            border
            style="width: 100%; margin-top: 30px"
            :header-cell-style="{ color: '#0B52A3', textAlign: 'center' }"
            :cell-style="{ color: '#000', textAlign: 'center' }"
          >
            <el-table-column prop="labItemName" width="150px" label="序号">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="userName"
              width="150px"
              label="姓名"
            ></el-table-column>
            <el-table-column
              prop="time"
              min-width="180"
              label="时间"
            ></el-table-column>
            <el-table-column
              prop="deviceName"
              min-width="100px"
              label="设备名称"
            ></el-table-column>
            <el-table-column
              prop="detail"
              min-width="150px"
              label="种类"
            ></el-table-column>
            <el-table-column
              prop="detailLevel"
              min-width="150px"
              label="严重程度"
            ></el-table-column>
            <el-table-column
              prop="score"
              min-width="150px"
              label="扣除信用积分"
            ></el-table-column>
          </el-table>
        </div>
        <div v-show="showIframe">
          <iframe
            :src="url"
            style="
              width: 1100px;
              min-height: 600px;
              margin: 0px;
              padding: 0px;
              border: 0;
              overflow-y: hidden;
            "
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "detail",
  data() {
    return {
      mainData: [],
      showBadRecord: false,
      url: "",
      showIframe: false,
      contentId: this.$route.params.contentId,
      contentIds: this.$route.params.contentIds,
      fullscreenLoading: false,
      content: {
        files: [],
      }, //内容
      firstMenuName: "",
      secondId: "",
      menuList: [],
      isShowSelect: false,//是否显示下拉菜单
      activeMenuIndex:0,
      menuName:""
    };
  },
  methods: {
    toggleDropdown(){
      this.isShowSelect = !this.isShowSelect;
      const dropdown = document.querySelector('.dropdown');
      dropdown.classList.toggle('open');
    },
    // 获取不良积分数据
    getTableList() {
      var fd = new FormData();
      fd.append("userId", sessionStorage.getItem("userId"));
      fd.append("pageNum", 1);
      fd.append("pageSize", 999);

      this.fullscreenLoading = true;
      axios
        .post("creditSystem/selectFlow", fd, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {
          this.mainData = response.data.data;
          this.fullscreenLoading = false;
        })
        .catch((error) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "数据请求失败，请重试。",
            type: "error",
          });
        });
    },
    getContent() {
      this.fullscreenLoading = true;
      var fd = new FormData();
      fd.append("contentId", this.contentId);
      axios
        .post("/cmsapi/contents", fd, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((response) => {
          var recData = response.data;
          document.title=recData.content.title;
          this.content = recData.content;
          document.getElementById('newsContent').innerHTML=this.content.contentString;
          this.secondId = recData.secondId;
          this.firstMenuName = recData.firstMenuName;
          this.menuId = recData.firstMenuId;
          this.getSecondList(recData.secondId)
          this.fullscreenLoading = false;
        })
        .catch((error) => {
          this.fullscreenLoading = false;
        });
    },
    getSecondList(id){
      console.log('执行')
      axios
        .post('/cmsapi/menus/' + id, {
          //顶部友情链接
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }).then(res=>{
        console.log(res,'res')
        this.menuName=res.data.menuName
        if(res.data.secondMenu.length > 0){
          res.data.secondMenu.forEach((item, index) => {
            this.menuList.push(item)
          });
        }else{
          this.menuList.push({
            label: res.data.firstMenuName,
            id: res.data.menuId,
          })
        }
        let matchIndex = this.menuList.findIndex(c => c.label == this.menuName);
        if (matchIndex != -1) {
          this.activeMenuIndex = matchIndex;
        }
      })
    },
    toList: function (menuId,name,index) {
      console.log(menuId,',menuId')
      this.activeMenuIndex = index;
      if(this.firstMenuName == '教学资源'){
        this.$router.push({
          path: "ListTeach:menuId",
          name: "ListTeach",
          params: { menuId: menuId },
        });
      }else{
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: menuId },
        });
      }
      this.toggleDropdown()
    },
    downloadFile(fileItem) {
      //下载文件
      if (fileItem.password == "1") {
        //有密码
        this.$prompt("下载该附件需要密码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then((value) => {
            window.open(
              "/mainsys/cmsapi/downloadFile?fileId=" +
              fileItem.id +
              "&password=" +
              value.value
            );
          })
          .catch(() => {
            this.$message.info("取消下载");
          });
      } else {
        // var fd = new FormData();
        // fd.append("fileId", fileItem.id);
        // fd.append("password",'');
        // axios.post("/cmsapi/getFilePath", fd, {
        //   headers: { "Content-Type": "application/x-www-form-urlencoded" }
        // });
        window.open(
          "/mainsys/cmsapi/downloadFile?fileId=" + fileItem.id + "&password="
        );
      }
    },
  },
  mounted() {
    this.getContent();
    if (this.$route.params.label == "仪器预约记录") {
      this.url = this.targetUrl + "lems/synOrderIframeRecord";
      this.showIframe = true;
    } else if (this.$route.params.label == "使用记录") {
      this.url = this.targetUrl + "lems/synUseIframeRecord/my";
      this.showIframe = true;
    } else if (this.$route.params.label == "实验室预约记录") {
      this.url = this.targetUrl + "open/MyIframeAppointment";
      this.showIframe = true;
    } else if (this.$route.params.label == "考勤记录") {
      this.url =
        this.targetUrl + "mainsys/scheduling/QueryTimetableList.jsp?type=tea";
      this.showIframe = true;
    } else if (this.$route.params.label == "实验室信息") {
      this.url = this.targetUrl + "LabOverview/getCenterIframePage/cms";
      this.showIframe = true;
    } else if (this.$route.params.label == "违规扣分处罚信息") {
      this.getTableList();
      this.showBadRecord = true;
    } else if (this.$route.params.label == "成绩查询") {
      var type = sessionStorage.getItem("schType");
      if (type == "s") {
        this.url =
          this.targetUrl +
          "mainsys/scheduling/score/NewGradeOfCourse.jsp?type=manager";
      } else {
        this.url =
          this.targetUrl +
          "mainsys/scheduling/score/NewGradeOfCourse.jsp?type=select";
      }
      this.showIframe = true;
    } else {
      this.showIframe = false;
    }

    // this.$nextTick(() => {
    //   if (this.$route.params.menuId) {
    //     this.menuId = this.$route.params.menuId;
    //     this.getSecondList();
    //   }
    // });
  },
  created() {


    // sessionStorage.setItem('schType',data.data.schType)
  },
};
</script>
<style scoped lang="less">
.container{
  width: 100%;
  padding: 10px;
  min-height: 800px;
  position: relative;
  .bgTitle{
    background: url("~@/assets/list/mobileTitle_bg.jpg") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 60px;
    padding: 3px 10px 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p{
      font-size: 24px;
      color: #fff;
    }
  }
  .dropdown {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .dropdown-header {
    //padding: 10px;
    cursor: pointer;
    user-select: none; /* 防止文本被选择 */
    background: url("~@/assets/list/mobileTitle_bg.jpg") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 60px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p{
      font-size: 18px;
      color: #fff;
      font-weight: bold;
    }
  }

  .dropdown-content {
    max-height: 0;
    overflow: auto;
    position: absolute;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    width: 100%; /* 确保宽度和头部一致 */
    transition: max-height 0.5s ease-out; /* 动画效果 */
  }
  .active_dropdown-item{
    padding: 10px;
    cursor: pointer;
    height: 50px;
    font-size: 18px;
    font-weight: bold;
    color: #002b9e;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .dropdown-item {
    padding: 10px;
    cursor: pointer;
    height: 50px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .dropdown.open .dropdown-content {
    max-height: 200px; /* 调整最大高度以适应所有项目 */
    background-color: #f2f2f2;
  }
}
/deep/ .content img{
  max-width: 100%;
  margin: auto;
  height: auto;
}
/deep/ .content a{
  word-wrap: break-word;
}
</style>
